"use strict";
import { createLpPosition, increaseLpPosition } from "data/apiClients/tradingApi/TradingApiClient";
import { InterfaceEventNameLocal } from "features/telemetry/constants";
import { sendAnalyticsEvent } from "features/telemetry/send";
import { parseErrorMessageTitle } from "features/transactions/liquidity/utils";
import { TransactionStepType } from "features/transactions/steps/types";
import {
  validateTransactionRequest
} from "features/transactions/swap/utils/trade";
import { logger } from "utilities/src/logger/logger";
export function createIncreasePositionStep(txRequest) {
  return {
    type: TransactionStepType.IncreasePositionTransaction,
    txRequest
  };
}
export function createIncreasePositionStepBatched(batchedTxRequests, fallbackSteps) {
  return {
    type: TransactionStepType.IncreasePositionTransactionBatched,
    batchedTxRequests,
    fallbackSteps
  };
}
export function createCreatePositionAsyncStep(createPositionRequestArgs) {
  return {
    type: TransactionStepType.IncreasePositionTransactionAsync,
    getTxRequest: async (signature) => {
      if (!createPositionRequestArgs) {
        return void 0;
      }
      try {
        const { create } = await createLpPosition({
          ...createPositionRequestArgs,
          signature,
          simulateTransaction: true
        });
        return validateTransactionRequest(create);
      } catch (e) {
        const message = parseErrorMessageTitle(e, { includeRequestId: true });
        if (message) {
          logger.error(message, {
            tags: {
              file: "increasePosition",
              function: "createCreatePositionAsyncStep"
            }
          });
          sendAnalyticsEvent(InterfaceEventNameLocal.CreatePositionFailed, {
            message
          });
        }
        throw new Error("create failed to get transaction request", {
          cause: message
        });
      }
    }
  };
}
export function createIncreasePositionAsyncStep(increasePositionRequestArgs) {
  return {
    type: TransactionStepType.IncreasePositionTransactionAsync,
    getTxRequest: async (signature) => {
      if (!increasePositionRequestArgs) {
        return void 0;
      }
      try {
        const { increase } = await increaseLpPosition({
          ...increasePositionRequestArgs,
          signature,
          simulateTransaction: true
        });
        return validateTransactionRequest(increase);
      } catch (e) {
        const message = parseErrorMessageTitle(e, { includeRequestId: true });
        if (message) {
          logger.error(message, {
            tags: {
              file: "generateTransactionSteps",
              function: "createIncreasePositionAsyncStep"
            }
          });
          sendAnalyticsEvent(InterfaceEventNameLocal.IncreaseLiquidityFailed, {
            message
          });
        }
        throw new Error("increase failed to get transaction request", {
          cause: message
        });
      }
    }
  };
}
